import axios from "axios";
import get from "lodash/get";
import { terminateSession } from "../redux/actions/authConfig.action";
import { hideErrorPage, showErrorPage } from "../redux/actions/common.action";
import { removeUserEmailStorage, removeUserStorage } from "./browserStorage";

import { isServer } from "./index";
import { getUserAgent } from "./common";

export const handleFetchError = (error: Error, dispatch) => {
  const errorStatus = get(error, "response.status");

  if (dispatch && errorStatus && errorStatus >= 400) {
    dispatch(hideErrorPage());
    switch (errorStatus) {
      case 400:
      case 422:
        const errorMessage = get(error, "response.data.message");
        console.error(
          errorMessage
            ? `The call got ${errorStatus} code with a message: ${errorMessage}`
            : error
        );
        break;

      case 404:
        dispatch(showErrorPage("is404", true));
        // Suppress verbose logging for expected 404 errors (invalid URLs)
        // Only log a simple message instead of the full stack trace
        const errorMessage404 = get(
          error,
          "response.data.message",
          "Url not exists."
        );
        if (isServer) {
          // On server, log a concise message for 404s
          console.warn(
            `404: ${errorMessage404} - URL: ${get(
              error,
              "config.data",
              "unknown"
            )} : userAgent: ${getUserAgent(error)}`
          );
        }
        // Don't log full error stack for 404s as they're expected for invalid URLs
        return;

      case 409:
        if (!isServer) {
          removeUserStorage();
          removeUserEmailStorage();
        }

        dispatch(terminateSession());
        break;

      case 500:
        dispatch(showErrorPage("is500", true));
        // Suppress verbose logging for 500 errors caused by invalid inputs (like invalid country codes)
        const errorMessage500 = get(
          error,
          "response.data.message",
          "Internal server error"
        );
        if (isServer) {
          // On server, log a concise message for 500s
          const requestUrl = get(error, "config.url", "unknown");
          console.warn(
            `500: ${errorMessage500} - URL: ${requestUrl} : : userAgent: ${getUserAgent(
              error
            )}`
          );
        }
        // Don't log full error stack for 500s as they're often expected for invalid inputs
        return;

      default:
        dispatch(showErrorPage("is503", true));
    }
  }

  if (axios.isCancel(error)) {
    console.error("Request cancelled:", error.message);
  } else {
    // Only log full error for non-404 and non-500 errors
    if (errorStatus !== 404 && errorStatus !== 500) {
      console.error(error);
    }
  }
};

export const internalServerError = (res, dispatch) => {
  if (res.data && res.data.success === false && dispatch) {
    dispatch(hideErrorPage());
    dispatch(showErrorPage("is500", true));
  }
};

export const errorOnUserSide = errorCode =>
  errorCode && errorCode >= 400 && errorCode < 500;
